import { apiV3Typed } from 'Services/api/apiV3';
import { buildTypedResponse } from 'Utils/buildResponse';

import { getUserCookieKey } from '../utils';

export const getGiftLinks = async () => {
  const response = await apiV3Typed.get('account/{cookie_key}/shared_links', {
    path: {
      cookie_key: getUserCookieKey(),
    },
  });

  return buildTypedResponse(response, 'sharedLink');
};
